import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Label,
} from "recharts";
import formatDefectLogData from "./formatDefectLogData";

// #endregion
const DefectAreaChart = ({ issues_log, issues, assigned }) => {
  const defectData = formatDefectLogData(issues_log, issues, assigned);

  const maxYValue = Math.max(
    ...defectData.map(
      (data) => data.open + data.closed + data.pending + data.inprogress,
    ),
  );

  function populateDescendingFor(maxNum) {
    const result = [];
    for (let i = maxNum; i >= 0; i--) {
      result.push(i);
    }
    const final = result.reverse();
    return final;
  }

  // console.log("maxYValue", maxYValue);
  // console.log("defectData", defectData);
  return defectData.length === 0 ? null : (
    <AreaChart
      style={{
        width: "100%",
        // height: "100%",
        // minWidth: "90%",
        height: "30vh",
        aspectRatio: 1.618,
      }}
      responsive
      data={defectData}
      margin={{
        top: 0,
        right: 0,
        left: 18,
        bottom: 0,
      }}
    >
      <CartesianGrid vertical={false} />
      <XAxis dataKey="name" />
      <YAxis
        width="auto"
        tickCount={maxYValue}
        tick={populateDescendingFor(maxYValue)}
      >
        <Label
          value="Issue Count"
          angle={-90}
          offset={-10}
          position="insideLeft"
          style={{
            textAnchor: "middle",
            fontSize: "16px",
            fontFamily: "Roboto",
            fill: "#333",
          }}
        />
      </YAxis>
      <Tooltip />
      <Area
        type="monotone"
        dataKey="open"
        stackId="1"
        stroke="#349fda"
        fill="#349fda"
      />
      <Area
        type="monotone"
        dataKey="inprogress"
        stackId="1"
        stroke="#fdd835"
        fill="#fdd835"
      />
      <Area
        type="monotone"
        dataKey="pending"
        stackId="1"
        stroke="#ff9800"
        fill="#ff9800"
      />
      <Area
        type="monotone"
        dataKey="closed"
        stackId="1"
        stroke="#50C878"
        fill="#50C878"
      />
    </AreaChart>
  );
};

export default DefectAreaChart;
